<template>
    <div>
        <div class="bg-light p-50 rounded border d-flex align-items-center justify-content-between" v-on:click="show = !show">
            <h5 class="mb-0">
                <span class="text-muted mr-25">
                    <feather-icon :class="(row.Warning)?'text-danger mr-50':'text-success mr-50'" :icon="(row.Warning)?'AlertCircleIcon':'CheckCircleIcon'" v-b-tooltip.noninteractive.hover.bottom="getMessage(row.Warning)"></feather-icon> 
                </span> 
                <span class="font-weight-bolder">{{$safe(row,'FullName') || '-'}}</span> 
                <span class="text-muted"> | </span> 
                <span class="text-secondary text-small">{{$safe(row,'IdentityNumber') || '-'}}</span>
                <span class="text-muted"> | </span> 
                <span class="text-muted text-small">{{$safe(row,'RegistrationNumber') || '-'}}</span>
            </h5>
            <div class="d-flex align-items-center">
                <b-badge variant="light-warning" class="mr-50" v-if="$safe(row,'Net') == false">Asgari Ücretli</b-badge>
                <b-badge variant="light-danger" class="mr-50" v-if="!row.Puan">Puantaj Hazırlık Bilgi Girişi Yapılmamış</b-badge>
                <h5 class="d-inline mb-0 font-weight-bolder mr-1" v-if="row.Puan">{{ $safe(row,'Net') ? $safe(row,'SumStr') :  $safe(row,'SumBrutStr') }}</h5>
                <feather-icon size="16" class="text-secondary" :icon="show ? 'ChevronDownIcon' : 'ChevronRightIcon'"></feather-icon>
            </div>
        </div>
        <b-collapse v-model="show">
            <table class="table table-bordered table-sm mt-25">
                <thead>
                    <tr>
                        <th>KYKM</th>
                        <th>G/S</th>
                        <!-- <th>Değer (Saat)</th> -->
                        <th>Net Ücret</th>
                        <th>Brüt Ücret</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="($safe(row,'Puantaj') || []).length > 0">
                        <tr v-bind:class="(pd.HasError)?'bg-light-danger':''" v-for="(pd,index) in row.Puantaj" :key="index">
                            <td class="w-25">
                                <feather-icon v-if="(pd.HasError)" class="text-danger mr-50" icon="AlertCircleIcon" v-b-tooltip.noninteractive.hover.bottom="getMessage(pd.Warning)"></feather-icon> 
                                {{$safe(pd,'KYKMName') || '-'}}
                            </td>
                            <td class="w-25">{{ $safe(pd,'Value') || '-'}}</td>
                            <!-- <td class="w-20">{{$safe(pd,'ValueMnt') || '-'}}</td> -->
                            <td :class="['w-25',{'bg-light':pd.TIP != 3 && $safe(row,'Net') == false}]" >
                                {{ pd.TIP == 3 ? ($safe(pd,'BrutStr') || '-') : $safe(row,'Net') ? ($safe(pd,'PriceStr') || '-') : '' }}
                            </td>
                            <td :class="['w-25',{'bg-light':pd.TIP == 3}]" >
                                {{ pd.TIP == 3 ? '' : $safe(row,'Net') ? '' : ($safe(pd,'BrutStr') || '-')}}
                            </td>
                            <!-- <td class="w-30" v-if="!(row.Puan)"><feather-icon class="text-danger mr-50" icon="AlertCircleIcon" v-b-tooltip.noninteractive.hover.bottom="getMessage('Netsis\'ten Puantaj Hazırlık Bilgi Girişi yapınız.')"></feather-icon> </td> -->
                        </tr>
                        <tr>
                            <td rowspan="3" class="font-weight-bolder bg-light-primary">TOPLAM</td>
                        </tr>
                        <tr>
                            <td class="font-weight-bolder bg-light-primary text-right">NET</td>
                            <td v-if="(row.Puan)" colspan="2" class="font-weight-bolder bg-light-primary">{{  $safe(row,'SumStr') }}</td>
                            <td v-if="!(row.Puan)" colspan="2" class="font-weight-bolder bg-light-danger"><feather-icon class="text-danger mr-50" icon="AlertCircleIcon" v-b-tooltip.noninteractive.hover.bottom="getMessage('Netsis\'ten Puantaj Hazırlık Bilgi Girişi yapınız.')"></feather-icon> </td>
                        </tr>
                        <tr class="border border-dark">
                            <td class="font-weight-bolder bg-light-primary text-right">BRÜT</td>
                            <td v-if="(row.Puan)" colspan="2" class="font-weight-bolder bg-light-primary">{{  $safe(row,'SumBrutStr') }}</td>
                            <td v-if="!(row.Puan)" colspan="2" class="font-weight-bolder bg-light-danger"><feather-icon class="text-danger mr-50" icon="AlertCircleIcon" v-b-tooltip.noninteractive.hover.bottom="getMessage('Netsis\'ten Puantaj Hazırlık Bilgi Girişi yapınız.')"></feather-icon> </td>
                        </tr>
                    </template>
                    <tr v-else>
                        <td class="text-center" colspan="3">
                            Sürücünün puantaj verileri bulunmamaktadır.
                        </td>
                    </tr>
                </tbody>
            </table>
        </b-collapse>
    </div>
</template>

<script>
import { VBTooltip,BCollapse, BBadge } from 'bootstrap-vue'

export default {
    components:{
        BCollapse,
        BBadge
    },
    directives:{
        "b-tooltip":VBTooltip
    },
    props:{
        row:Object,
        field:Object
    },
    data(){
        return {
            show:false
        }
    },
    computed:{
        total(){
            return this.row?.Puantaj?.reduce((s,t)=>{
                s += parseFloat(t.Price) || 0
                return s
            },0)?.toFixed(2) || Number(0).toFixed(2)
        }
    },
    methods: {
        getMessage(mes){
            return mes
        }

    }
}
</script>

<style>
.chevron{
    font-size: 2rem;
}
.dark-layout .bg-light-primary{
    color: white !important;
}
.text-small{
    font-size: 0.875rem;
}
</style>
